module.exports = __webpack_public_path__ + "static/media/27-3.a131f9a2.mp3";